"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M3 17h1V7H3zM20 7v10h1V7z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M14 11.25h-1.5v1.5H14zm2.5 0H15v1.5h1.5zm-5 0H10v1.5h1.5zm-2.5 0H7.5v1.5H9zM21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2M4 17H3V7h1zm14 0H6V7h12zm3 0h-1V7h1z"
}, "1")], 'SmartScreenTwoTone');